import toast from "react-hot-toast";

export function showToast(
  type: "success" | "error" | "warning" | "info",
  title: string,
  description?: string
) {
  const icons = {
    success: "✅",
    error: "❌",
    warning: "⚠️",
    info: "ℹ️",
  };

  return toast.custom((t) => (
    <div className="max-w-md w-full bg-white rounded-xl shadow-lg border p-4 flex gap-3">
      <div className="text-2xl">
        {icons[type]}
      </div>

      <div className="flex-1">
        <h4 className="font-semibold text-gray-900">
          {title}
        </h4>

        {description && (
          <p className="text-sm text-gray-500">
            {description}
          </p>
        )}
      </div>

      <button
        onClick={() => toast.dismiss(t.id)}
        className="text-gray-400"
      >
        ✕
      </button>
    </div>
  ));
}